import { Component, EventEmitter, Input, Output } from '@angular/core';
import { provideValueAccessor } from 's-ng-utils';

@Component({
  selector: 'ext-page-limit',
  template: `
    <div style="width: 150px; padding-top: 10px">
      <ext-select
        label="Rows per page:"
        textPropertyName="key"
        valuePropertyName="value"
        [(ngModel)]="limit"
        [items]="LIMITS"
        (selectionChange)="changeRowLimits($event.value)"
      ></ext-select>
    </div>
  `,
  providers: [provideValueAccessor(ExtPageLimitComponent)],
})
export class ExtPageLimitComponent {
  @Input() limit: number;
  @Output() changeValue: EventEmitter<number> = new EventEmitter();

  LIMITS = [
    { key: '10', value: 10 },
    { key: '25', value: 25 },
    { key: '50', value: 50 },
    { key: '100', value: 100 }
  ];

  changeRowLimits(event: number) {
    this.changeValue.emit(event);
  }
}
